import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Sobre from '../views/Sobre.vue'
import Servicos from '../views/Servicos.vue'
import TrabalheConosco from '../views/TrabalheConosco.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/sobre',
      name: 'sobre',
      component: Sobre
    },
    {
      path: '/servicos',
      name: 'servicos',
      component: Servicos
    },
    {
      path: '/trabalhe-conosco',
      name: 'trabalhe-conosco',
      component: TrabalheConosco
    }
  ]
})

export default router 